<template>
  <div>
    <b-container>
      <b-alert show>
        Das Projekt Kontrastive Alphabetisierung im Situationsansatz (KASA) ist
        seit dem 31.7.2022 beendet. Diese Homepage wird nicht weiter gepflegt.
      </b-alert>
    </b-container>
    <b-container>
      <b-jumbotron lead="Kostenlose Zusatzmaterialien zum Buch" id="search-jumbo">
        <h2 slot="header">Resourcen finden</h2>

        <b-form-input id="input-large" size="lg" type="text" placeholder="Schnellzugriffscode, Seitenzahl oder Kapitel eingeben" v-model="searchInput" autofocus></b-form-input>

        <div class="mt-4 text-center">
          <resource-type-filter :disabled="searchInput === ''" ref="resourceTypeFilter" :enable-default-all="true"></resource-type-filter>
        </div>
        <div class="mt-2 text-center">
          <resource-lang-filter :disabled="searchInput === ''" ref="resourceLangFilter" :enable-default-all="true"></resource-lang-filter>
        </div>

      </b-jumbotron>
    </b-container>

    <b-container class="results">
      <b-row>
        <b-col class="mb-4" cols="12" v-for="resource in searchResult" :key="resource.filePath  ">
          <resource :resource="resource"></resource>
        </b-col>

        <b-col v-if="searchResult.length <= 0 && searchInput.length >= minSearchInput" id="no-search-results" class="fadeIn animated">
          <h3>Keine Ergebnisse gefunden!</h3>
          <p>Es tut uns sehr leid, aber leider konnten keine Zusatzmaterialien für den Suchbegriff <code>{{ searchInput }}</code> gefunden werden.</p>

          <h4>Wie suche ich richtig?</h4>
          <p>Bitte geben Sie in das Suchfeld <b>eine</b> der folgenden drei Informationen ein:</p>
          <ul>
            <li>Seitenzahl der Verlinkung</li>
            <li>Kapitelnummer der Verlinkung</li>
            <li>Schnellzugriffscode des Materials (z.B. <code>tr_1</code> oder <code>ar_2</code>)</li>
          </ul>
          <p>Stellen Sei außerdem sicher, dass Sie die gewünschten Typen von Materialien unter dem Suchfeld angewählt haben.</p>
        </b-col>

        <b-col v-if="searchInput.length < minSearchInput && searchInput.length > 0" id="too-short-search" class="fadeIn animated">
          <h3>Eingegebener Suchbegriff zu kurz</h3>
          <p>Bitte geben Sie einen Suchbegriff von mindestens <b>{{ minSearchInput }} Zeichen</b> ein.</p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import Resource from './Resource'
  import ResourceTypeFilter from './ResourceTypeFilter'
  import ResourceLangFilter from './ResourceLangFilter'

  const Loki = require('lokijs')

  export default {
    name: 'ResourceSearch',
    data () {
      return {
        searchInput: '',
        minSearchInput: 3
      }
    },
    components: {
      Resource,
      ResourceTypeFilter,
      ResourceLangFilter
    },
    mounted () {
      this.$http.get('/static/resourceDB.json').then(function (response) {
        this.db = new Loki('resources')
        this.db.loadJSONObject(response.body)
        this.resourceCollection = this.db.getCollection('resources')
        this.topicsCollection = this.db.getCollection('topics')

        if (this.$route.params.searchString) {
          this.searchInput = this.$route.params.searchString
        }

        if (this.$route.query.lang) {
          this.$refs.resourceLangFilter.selectOnlyLang(this.$route.query.lang)
        }
      })
    },
    computed: {
      filteredResources: function () {
        if (this.resourceCollection !== null) {
          return this.resourceCollection.chain().where((obj) => {
            if (this.$refs.resourceTypeFilter !== undefined) {
              return this.$refs.resourceTypeFilter.filterSelectedObjects(obj)
            }
            return false
          }).where((obj) => {
            if (this.$refs.resourceLangFilter !== undefined) {
              return this.$refs.resourceLangFilter.filterSelectedObjects(obj)
            }
            return false
          })
        }
      },
      searchResult: function () {
        if (this.searchInput === '' || this.searchInput.length < this.minSearchInput) {
          return []
        }

        const searchInputLower = this.searchInput.toLowerCase()

        let filteredTopics
        filteredTopics = this.topicsCollection.where((obj) => {
          if (obj['quickAccessCode'] !== undefined && obj['quickAccessCode'].toLowerCase() === searchInputLower) {
            return true
          }

          if (obj['title'] !== undefined && obj['title'].toLowerCase().includes(searchInputLower)) {
            return true
          }

          if (obj['description'] !== undefined && obj['description'].toLowerCase().includes(searchInputLower)) {
            return true
          }

          for (const tagIdx in obj['tags']) {
            if (obj['tags'][tagIdx].toLowerCase().includes(searchInputLower)) {
              return true
            }
          }
          return false
        }).map((oldData) => {
          return oldData['title']
        })

        return this.filteredResources.branch().where((obj) => {
          if (obj['quickAccessCode'] !== undefined && obj['quickAccessCode'].toLowerCase() === searchInputLower) {
            return true
          }

          if (obj['title'] !== undefined && obj['title'].toLowerCase().includes(searchInputLower)) {
            return true
          }

          const intInput = parseInt(this.searchInput)
          if (!isNaN(intInput)) {
            if (obj['page'] === intInput) {
              return true
            }
            if (obj['chapter'] === intInput) {
              return true
            }
          }

          for (const tagIdx in obj['tags']) {
            if (obj['tags'][tagIdx].toLowerCase().includes(searchInputLower)) {
              return true
            }
          }

          if (filteredTopics.includes(obj['topic'])) {
            return true
          }

          return false
        }).simplesort('page').data()
      }
    },
    methods: {
      getLanguageString (lang) {
        if (lang === 'ar') {
          return 'Arabisch'
        } else if (lang === 'tr') {
          return 'Türkisch'
        } else if (lang === 'pr') {
          return 'Persisch'
        } else {
          return 'Unbekannt'
        }
      }
    }
  }
</script>


<style lang="scss" scoped>
  @import '../style/bootstrap-component-include';
  @import '~animate.css/animate.css';

  .container {
    margin-top: 15px;
  }

  #no-search-results, #too-short-search {
    animation-delay: 1.5s;
  }

  #search-jumbo {
    position: relative;
    z-index: 0;
  }

  .results {
    min-height: 50vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/ResourceSearch.vue